import React, { useEffect, useState } from "react";
import SwipeableViews from "react-swipeable-views";
import SwipeItems from "./SwipeItems/SwipeItems";
import "./styles.css";
import "react-swipeable-views/dist/legacy-browser-support.css";
import { useWindowHeight } from "../../customHooks/useWindowHeight";

interface IMenuContentsContainerProps {
  menuItemState: any;
  menuItemRaw: IMenuItem[];
  position: number;
  onChangePosition: (index: number, indexLatest?: number) => void;
  searchIndex: number;
  searchText: string;
}

function MenuContentsContainer({
  menuItemRaw,
  menuItemState,
  position,
  onChangePosition,
  searchIndex,
  searchText,
}: IMenuContentsContainerProps) {
  const [elements, setElements] = useState<JSX.Element[]>([]);
  const windowHeight = useWindowHeight({ isResizeable: false });
  console.log(searchText);
  useEffect(() => {
    setElements([...renderListItemsToElements()]);
    //eslint-disable-next-line
  }, [menuItemState, menuItemRaw]);
  function renderListItemsToElements() {
    if (menuItemState === undefined) {
      return [];
    }
    const categoryKeys = Object.keys(menuItemState);

    const elements = [];
    for (let i = 0; i < categoryKeys.length; i++) {
      const treeSubCats = menuItemState[categoryKeys[i]].subCats;
      for (const subKeys in treeSubCats) {
        const subCat = treeSubCats[subKeys];
        const menuItems = subCat.menuItems;
        elements.push(
          <div key={subKeys}>
            <SwipeItems
              key={`swipe-${subCat.index}`}
              data={menuItems}
              windowHeight={windowHeight}
            />
          </div>
        );
      }
    }
    elements.push(
      <div key={searchIndex}>
        <SwipeItems
          key={`swipe-${searchIndex}`}
          data={getRawSearch()}
          windowHeight={windowHeight}
        />
      </div>
    );
    return elements;
  }
  useEffect(() => {
    if (elements.length > 0) {
      setElements([...updateSearchIndex()]);
    }
    //eslint-disable-next-line
  }, [searchText]);
  function updateSearchIndex() {
    const newElements = elements;
    const searchList = getRawSearch();
    newElements.splice(
      searchIndex,
      1,
      <div key={searchIndex}>
        <SwipeItems
          key={`swipe-${searchIndex}`}
          data={searchList}
          windowHeight={windowHeight}
        />
      </div>
    );
    return newElements;
  }
  function getRawSearch() {
    if (searchText.length === 0) {
      return menuItemRaw;
    }
    return menuItemRaw.filter((menuItem) =>
      menuItem.menu_item_name_public.toLowerCase().includes(searchText)
    );
  }
  return (
    <div
      data-component-name="menu_container"
      className="menu_contents"
      style={{
        overflow: "hidden",
      }}
    >
      <SwipeableViews
        onChangeIndex={onChangePosition}
        index={position}
        enableMouseEvents
      >
        {elements}
        {/* {fakeSlides()}  */}
        {/* {renderListItemsToElements()} */}
      </SwipeableViews>
    </div>
  );
}

export default MenuContentsContainer;
